<template>
    <section class="card card-info card-outline mb-4" role="region">
        <template v-if="station.enable_station_requests">
            <div class="card-header">
                <h3 class="card-title">
                    Song Requests
                    <small class="badge badge-pill badge-success">Enabled</small>
                </h3>
            </div>
            <div class="card-body">
            <div class="card-actions" v-if="userCanManageReports || userCanManageProfile">
                <a class="btn btn-outline-info btn-sm" v-if="userCanManageReports" :href="requestsViewUri">
                    <i class="fas fa-file-alt"></i>
                    View
                </a>
                <button :disabled="processing" @click.prevent="toggleRequests" class="btn btn-outline-success btn-sm">
                     <i class="fas fa-times"></i>
                     {{processing? 'disabling...':'Disable'}}
                </button>
            </div>
            </div>
        </template>
        <template v-else>
            <div class="card-header">
                <h3 class="card-title">
                    Song Requests
                    <small class="badge badge-pill badge-danger" >Disabled</small>
                </h3>
            </div>
             <div class="card-body">
            <div class="card-actions" v-if="userCanManageProfile">
                  <button :disabled="processing" @click.prevent="toggleRequests" class="btn btn-outline-success btn-sm">
                    <i class="fas fa-check"></i>
                     {{processing? 'enabling...':'Enable'}}
                </button>
            </div>
             </div>
        </template>
    </section>
</template>

<script>


export default {
   
   data(){
       return {
        enableRequests: Boolean,
        userCanManageReports: true,
        userCanManageProfile: true,
        requestsViewUri: '!#',
        toggleRequestsUri: 'admin/station/requests',
        processing: false
       }
   },
    methods: {
           toggleRequests(){
               this.processing = true
            axios.post(this.toggleRequestsUri).then( (res) => {
                this.$store.commit('updateStation', res.data)
                  this.processing = false
        })
    }
}

}

</script>
